import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import { useQueryClient } from "@tanstack/react-query";
import { displayNotify } from "../../../../../shared/services/Notifications/NotificationServices";

interface FormValues {
    id?: string,
    name: string,
    description: string,
    is_registration_allowed: boolean,
    size_limit: number
}

export default function useEditSide(guID?: string) {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn:
            (formData: FormValues) =>
                axios.patch(`/events/${guID}/parties/${formData.id}/`, {
                    name: formData.name,
                    description: formData.description,
                    is_registration_allowed: formData.is_registration_allowed,
                    size_limit: formData.size_limit
                }),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['events', guID] });
            displayNotify({
                status: 'success',
                title: 'Изменения сохранены',
                description: 'Данные о стороне успешно обновлены'
            })
        }
    })
}